
import axios from 'axios';
import router from '../router';
import {  Message } from 'element-ui'
let qs = require('qs');
import {setCookie, getCookie, delCookie, clearCookie} from '@/utils/cookieUtil';

import {baseServerUrl,shareWebUrl } from '@/api/public'
 axios.defaults.baseURL = '/prod-api';
if (window.localStorage.getItem('sysToken')) {
  axios.defaults.headers.common['token'] = window.localStorage.getItem('sysToken');
}
if (window.localStorage.getItem('sysUserId')) {
  axios.defaults.headers.common['userId'] = window.localStorage.getItem('sysUserId');
}
if(window.localStorage.getItem('userName')){
  axios.defaults.headers.common['userName'] = encodeURI(window.localStorage.getItem('userName'))
}
axios.defaults.headers.common['systemType'] = "pcOperation";
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
// Add a response interceptor
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  // Do something with response error
  return Promise.reject(error);
})
function getReq(url,data) {
  return new Promise((resolve, reject) => {
	  
    axios.get(url,{params:data}).then(res=>{
		if (res.data.code===200) {
			 resolve(res.data)
		  
		}else{
			if(res.data.code == '201'){
		         Message.error('token失效，请重新登录');
		        window.location.replace(shareWebUrl)
		    }else{
					  Message.error(res.data.msg)
				  }
		}
    }).catch(er => {
      reject(er)
    })
  })
}
function getUserReq(url,data) {
  return new Promise((resolve, reject) => {
	  if (window.localStorage.getItem('token')) {
	      axios.defaults.headers.common['token'] = window.localStorage.getItem('token');
	  }
    axios.get(url,{params:data}).then(res=>{
      resolve(res.data);
    }).catch(er => {
      reject(er)
    })
  })
}
function postReq(url,data) {
 
  return new Promise((resolve, reject) => {
	      axios.defaults.headers.common['Content-Type'] = 'application/json';

      if (window.localStorage.getItem('token')) {
          axios.defaults.headers.common['token'] = window.localStorage.getItem('token');
		 
      }
    axios.post(url,data).then(res=>{
      res.data = typeof res.data === 'string'?JSON.parse(JSON.stringify(res.data)):res.data;
      if (res.data.code!==200) {
         
        Message({
          message: res.data.msg,
          type: 'error',
        })
        
      }else{
          if(res.data.msg == '会话过期，请重新登录'){
              Message.error('token失效，请重新登录');
              window.location.replace(shareWebUrl)
          }else if(res.data.code == 403){
               Message.error('token失效，请重新登录');
              window.location.replace(shareWebUrl)
          }else{
			  resolve(res.data.data)
		  }
      }
     
    }).catch(er => {
      reject(er)
    })
  })
}
export async function getFetch(url,data) {
  let re = await getReq(url,data)
  return re
}
export async function getUserFetch(url,data) {
  let re = await getUserReq(url,data)
  return re
}
export async function postFetch(url,data) {
  let re = await postReq(url,data)
  return re
}

export default {
  getFetch: getFetch,
  postFetch: postFetch,
  getUserFetch:getUserFetch
}
